<template>
    <div>
        <div class="indicator-selectors">
            <indicator-selector-single
                    v-for="(singleValue, n) in value"
                    :key="n"
                    :indicatorNumber="n + 1"
                    :canDelete="indicatorCount > 1"
                    :allIndicators="allIndicators"
                    v-model="value[n]"
                    class="mb-3"
                    v-on:add="onAdd"
                    v-on:delete="onDelete"/>
        </div>
        <button class="btn btn-primary mb-3" v-on:click="onAdd">Add indicator</button>
    </div>
</template>

<script>
    import IndicatorSelectorSingle from "./single-selector";

    export default {
        name: 'indicator-selector',
        components: {
            IndicatorSelectorSingle
        },
        props: {
            value: {
                type: Array,
                default() {
                    return [];
                }
            },
            allIndicators: {
                type: Array,
            }
        },
        computed: {
            indicatorCount() {
                return this.value.length;
            }
        },
        mounted() {
            if (!this.value || !this.value.length) {
                this.onAdd();
            }
        },
        methods: {
            onAdd() {
                this.value.push({
                    indicatorId: null,
                    observationGroupId: null,
                    dependencies: {}
                });
            },
            onDelete(indicatorNumber) {
                this.value.splice(indicatorNumber - 1, 1);
            }
        }
    }
</script>
